import { useAddressSystemStore } from '@/store/addressSystem'
import { useBasketStore } from '@/store/basket/basket'
import { useDialogsStore } from '@/store/dialogs/dialogs'
import { DIALOGS } from '@/store/dialogs/dialogs.constants'
import { useToggleStore } from '@/store/toggle/toggle'
import { useUserStore } from '@/store/user/user'

export const useMenuByPointsDialog = () => {
  const { $metrics } = useNuxtApp()
  const userStore = useUserStore()
  const addressSystemStore = useAddressSystemStore()
  const basketStore = useBasketStore()
  const { showDialog, closeDialog } = useDialogsStore()
  const { menuByPointsEnabled } = useToggleStore()

  // Проверка установленного адреса в виджете АС
  const showMenuByPointsDialogs = (additionalDialog?: boolean) => {
    if (!menuByPointsEnabled) return

    const isAddressExist = userStore.isAuthenticated
      ? basketStore.data.delivery?.order_address
      : addressSystemStore.deliveryWidget?.order_address

    if (isAddressExist) return

    // Если авторизован и нет адреса, то открываем ДО АС. Если не авторизован и нет адреса, показываем ДО проверки адреса
    if (userStore.isAuthenticated) {
      closeDialog(DIALOGS.PRODUCT)

      setTimeout(() => {
        addressSystemStore.setVisibleAddressSystemDialog(true)
      }, 100)
    } else {
      showDialog(DIALOGS.CHECK_ADDRESS, { additional: additionalDialog })
    }

    // Попытка добавить блюдо без адреса (триггер попапа)
    $metrics?.eventSendGoal({ ym: 'dish_added_to_cart_attempt' })

    return true
  }

  return { showMenuByPointsDialogs }
}
